import { SpecialAction } from '../SpecialAction';

export class SpecialPrepareToFight extends SpecialAction {
    id = '*prepare-to-fight';
}
